import SchoolGroupInfo from './SchoolGroupInfo.page';

export default SchoolGroupInfo;
